import { FC, ReactNode } from "react"
import { SpinnerCircular } from "spinners-react"
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react"
import { cutWalletName } from "utils/cutWalletName"
import "./index.scss"

export type IButtonWalletV1 = {
  notConnectedTitle: string
  notConnectedDescription: string
  coinIcon: ReactNode
  wallet: string
  sideIcon: ReactNode
  onClickConnected: () => void
  onClickNotConnected: () => void
  isLoading?: boolean
}

export const ButtonWalletV1: FC<IButtonWalletV1> = ({
  notConnectedTitle,
  notConnectedDescription,
  coinIcon,
  wallet,
  sideIcon,
  onClickConnected,
  onClickNotConnected,
  isLoading = false
}) => {
  const rawAddress = useTonAddress(false)
  const [tonConnectUI] = useTonConnectUI()

  const NotConnectedUI = (
    <>
      {isLoading ? (
        <SpinnerCircular
          className="loading-spinner-wallet"
          size={20}
          color="#35262699"
        />
      ) : null}
      <div
        className={["not-connected-wallet-wrapper", isLoading ? "hidden" : null]
          .filter((el) => el)
          .join(" ")}
      >
        <span className="not-connected-title">{notConnectedTitle}</span>
        <span className="not-connected-description">
          {notConnectedDescription}
        </span>
      </div>
    </>
  )

  const ConnectedUI = (
    <>
      {isLoading ? (
        <SpinnerCircular
          className="loading-spinner"
          size={20}
          color="#35262699"
        />
      ) : null}
      <div
        className={["connected-wallet-wrapper", isLoading ? "hidden" : null]
          .filter((el) => el)
          .join(" ")}
      >
        <div className="connected-wallet-address">
          {coinIcon}
          <span>{cutWalletName(wallet, 2)}</span>
        </div>
        {sideIcon}
      </div>
    </>
  )

  return (
    <button
      className={wallet ? "connected" : "not-connected"}
      onClick={
        wallet
          ? onClickConnected
          : async () => {
              if (rawAddress) {
                await tonConnectUI.disconnect()
              }
              onClickNotConnected()
            }
      }
    >
      {wallet ? ConnectedUI : NotConnectedUI}
    </button>
  )
}
